import { render, staticRenderFns } from "./NotFound_view.vue?vue&type=template&id=30de0a1e&scoped=true&"
import script from "./NotFound_view.vue?vue&type=script&lang=js&"
export * from "./NotFound_view.vue?vue&type=script&lang=js&"
import style0 from "./NotFound_view.vue?vue&type=style&index=0&id=30de0a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de0a1e",
  null
  
)

export default component.exports